import { useState } from "react";
import {
  Box,
  IconButton,
  Icon,
  Tooltip,
  Typography,
  ButtonGroup,
  Button,
} from "@mui/material";
import { map } from "lodash";
import TabelaBase, { CelulaTexto } from "./tabelaBase";
import Usuario from "../../../models/usuario";
import { IconShieldCheck, IconUserOff } from "@tabler/icons-react";
import { useUsuario } from "../../../providers/usuarioProvider";
import { Perfil } from "../../../models/enum";
import PermissaoDisplay from "../permissaoDisplay";
import ExcluircolaboradorDialog from "../../app/conta/business/excluirColaboradorDialog";
import FelixAvatar from "../ui/felixAvatar";
import { useNavigate } from "react-router-dom";

type Props = {
  colaboradores: Usuario[];
};

export default function TabelaColaboradores({ colaboradores }: Props) {
  const navigate = useNavigate();
  const { usuario } = useUsuario();

  const header: {
    titulo: string;
    key: string;
    ordem: number;
    align: "left" | "center" | "right";
  }[] = [
    { titulo: "Nome", key: "nome", ordem: 1, align: "left" },
    { titulo: "Email", key: "email", ordem: 2, align: "left" },
    { titulo: "", key: "acoes", ordem: 3, align: "right" },
  ];

  const rows = map(colaboradores, (colaborador) => ({
    nome: celulaNome(colaborador),
    email: celulaEmail(colaborador),
    acoes: celulaAcoes(colaborador),
  }));

  return <TabelaBase header={header} rows={rows} />;

  function celulaNome(colaborador: Usuario): JSX.Element {
    return (
      <Box display="flex" flexDirection="row" alignItems="center">
        <FelixAvatar
          nome={colaborador.nome}
          size={40}
          perfil={Perfil.CONTADOR}
          fotoDePerfil={colaborador.fotoDePerfil}
        />

        <Box mr={1} />
        <Typography fontWeight={500}>{colaborador.nome}</Typography>
      </Box>
    );
  }

  function celulaEmail(colaborador: Usuario): JSX.Element {
    return <CelulaTexto texto={colaborador.email} />;
  }

  function celulaAcoes(colaborador: Usuario): JSX.Element {
    if (colaborador.id !== usuario?.id)
      return (
        <PermissaoDisplay
          match={(claims) => !!claims?.permissoes?.gerenciar_usuarios}
        >
          <ButtonGroup size="small" variant="outlined">
            <Tooltip title="Permissões">
              <Button
                color="info"
                onClick={() =>
                  navigate("/colaborador", {
                    state: { usuarioId: colaborador.id },
                  })
                }
              >
                <IconShieldCheck size={16} />
              </Button>
            </Tooltip>
          </ButtonGroup>

          <ExcluirUsuario colaborador={colaborador} />
        </PermissaoDisplay>
      );
    else return <></>;
  }
}

function ExcluirUsuario({ colaborador }: { colaborador: Usuario }) {
  const [openExcluir, setOpenExcluir] = useState(false);

  return (
    <>
      {openExcluir && (
        <ExcluircolaboradorDialog
          open={openExcluir}
          colaborador={colaborador}
          onClose={() => setOpenExcluir(false)}
        />
      )}
      <Tooltip title="Remover Acesso">
        <IconButton
          color="error"
          onClick={() => setOpenExcluir(true)}
          edge="end"
        >
          <Icon fontSize="inherit">
            <IconUserOff size={20} />
          </Icon>
        </IconButton>
      </Tooltip>
    </>
  );
}
